/**
 * CappedBars - the asks over the map's top edge, a third of the map at most (2026-10-22, plan retire-classic).
 *
 * The story bars and the mid-attack prompts lie over the map (`map-top-bars`); a defence chain, two test calls, a
 * disposition and a timer stacked down over the board with no limit, where classic pushed the map down. The row they
 * sit in (`.mapTop`) is a third of the map tall; past it the stack scrolls, the hidden side fades, and "▾ N MORE"
 * counts the bars wholly below and steps down a bar at a time. The caller puts the prompts that need an answer
 * first, so the one that matters is never the one below the fold.
 *
 * The scroll is useStripOverflow's, down a column as the muster's is: one owner of the measuring, the fades' geometry
 * and the step (a bar taller than the room is read a band at a time).
 */
import useStripOverflow from '../hooks/useStripOverflow';
import styles from '../styles/CombatLogPanel.module.css';

/** Down the stack, a bar at a time; each bar is a direct child. */
const COLUMN = { axis: 'y', seat: ':scope > *' };

function MoreButton({ below, onStep }) {
  return (
    <button type="button" className={styles.topBarsMore} data-testid="map-top-more" onClick={onStep}>
      ▾ {below > 0 ? `${below} MORE` : 'MORE'}
    </button>
  );
}

export default function CappedBars({ children }) {
  const { scrollerRef, state, step } = useStripOverflow(null, null, COLUMN);
  const more = state.overflow && !state.atEnd;
  return (
    <div className={styles.topBarsWrap}>
      <div ref={scrollerRef} className={styles.topBars} data-testid="map-top-bars" data-more={more || undefined}>
        {children}
      </div>
      {more && <MoreButton below={state.after} onStep={() => step(1)} />}
    </div>
  );
}
